import React from "react";
// core components
import { Col, Row } from 'reactstrap';

import { FaFileUpload, FaFolderPlus, FaTrash } from 'react-icons/fa'

import PropTypes from "prop-types";

import commonStyle from "commonStyle";

import Button from "components/Button";

import { withoutAuth } from "HOC"

export default class Sidebar extends React.Component {
  renderSingleSidebar = () => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div
        style={{
          width: '100%'
        }}
      >
        <Button>
          Download
        </Button>
      </div>
      <hr style={{ width: '100%' }}/>
      <div
        style={{
          paddingLeft: 20,
          paddingRight: 10,
          paddingTop: 13
        }}
      >
        <Row>
          <p
            style={{ height: 20, color: commonStyle.primaryColor}}
          >
            <FaTrash />
            <span style={{ paddingLeft: 7, fontWeight: 400 }}>Delete</span>
          </p>
        </Row>
      </div>
    </div>
  );

  renderMulitpleSidebar = () => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div
        style={{
          width: '100%'
        }}
      >
        <Button>
          Download all
        </Button>
      </div>
      <hr style={{ width: '100%' }}/>
      <div
        style={{
          paddingLeft: 20,
          paddingRight: 10,
          paddingTop: 13
        }}
      >
        <Row>
          <p
            style={{ height: 20, color: commonStyle.primaryColor}}
          >
            <FaTrash />
            <span style={{ paddingLeft: 7, fontWeight: 400 }}>Delete all</span>
          </p>
        </Row>
      </div>
    </div>
  );

  renderNoSelectionSidebar = () => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div
        style={{
          width: '100%'
        }}
      >
        <Button>
          Item
        </Button>
      </div>
      <hr style={{ width: '100%' }}/>
      <div
        style={{
          paddingLeft: 20,
          paddingRight: 10,
          paddingTop: 13
        }}
      >
        <Row>
          <p
            style={{ height: 20, color: commonStyle.primaryColor}}
          >
            <FaFileUpload />
            <span style={{ paddingLeft: 7, fontWeight: 400 }}>Upload file</span>
          </p>
        </Row>
        <Row>
          <p
            style={{ height: 20, color: commonStyle.primaryColor }}
          >
            <FaFolderPlus />
            <span style={{ paddingLeft: 7, fontWeight: 400 }}>Upload folder</span>
          </p>
        </Row>
      </div>
    </div>
  );

  renderSidebar = ({ oneSelected, multipleSelected }) => {
    let component = null;

    if (oneSelected) {
      component = this.renderSingleSidebar();
    } else if (multipleSelected) {
      component = this.renderMulitpleSidebar();
    } else {
      component = this.renderNoSelectionSidebar();
    }

    return component;
  }

  render() {
    return this.renderSidebar(this.props);
  }
}
